<ion-app>
  <router-outlet />
  @if (navVisible()) {
    <sz-tab-bar class="app-tab-bar" [items]="tabItems" [fabActive]="quickStart.isActive()" (fab)="onFabTap()" />
  }
  <lib-fab-quick-start-sheet />
</ion-app>
